export default {"src":"https://wp-static.smartkarma.com/_next/static/media/charting.e2f0ee75.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};